/**
 * URL utilities for audio CDN
 */
import { API_ENDPOINTS } from '../config/apiConfig';

/**
 * Converts relative audio paths to full CDN URLs
 * @param url Relative audio path from backend (e.g., "/audio/filename.mp3")
 * @returns Full CDN URL using configured base URL
 */
export const buildAudioUrl = (url: string): string => {
  if (!url) return url;

  // If already a full URL, return as-is
  if (url.startsWith('http')) {
    return url;
  }

  // Build full URL using CDN base URL
  // Backend returns: "/liveolympiad/assets/filename.mp3"
  // This constructs: "/api/cdn/liveolympiad/assets/filename.mp3", which the bff reads from the CDN
  const fullUrl = `${API_ENDPOINTS.cdnBaseUrl}${url}`;
  return fullUrl;
};

/**
 * Batch build audio URLs for question arrays
 */
export const buildQuestionAudioUrls = (questions: any[]): any[] => {
  return questions.map(question => ({
    ...question,
    mediaUrl: question.mediaUrl ? buildAudioUrl(question.mediaUrl) : question.mediaUrl
  }));
};